import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppStore } from '@aaa/emember/store-types';
import { RequestStatus } from '@aaa/emember/types';
import { map } from 'rxjs/operators';
import { first, tap } from 'rxjs';
import { getQuickRenewExecutionRequestStatus } from '@aaa/emember/store-quick-renew';
import { Pages } from '../../../constants/pages';

export const checkConfirmation: CanActivateChildFn = () => {
  const router = inject(Router);
  const store = inject(Store<AppStore>);

  return store.select(getQuickRenewExecutionRequestStatus).pipe(
    first(),
    map((executionRequestStatus) => executionRequestStatus === RequestStatus.SUCCESS),
    tap((success) => !success && router.navigateByUrl(Pages.renew)),
  );
};

export default checkConfirmation;
